import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=3ef96c1b"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=3ef96c1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports